import type React from "react";
import styles from "./Show.module.scss";

/** Must be in sync with _breakpoints.scss */
type Breakpoint = 550 | 700;

type ShowProps<T extends React.ElementType = "div"> = {
    breakpoint: Breakpoint;
    as?: T;
    className?: string;
    children: React.ReactNode;
} & Omit<React.ComponentPropsWithoutRef<T>, "as" | "children" | "className">;

function Below<T extends React.ElementType = "div">({ breakpoint, as, className, children, ...rest }: ShowProps<T>) {
    const Tag = as ?? "div";
    return (
        <Tag className={[styles[`below--${breakpoint}`], className].filter(Boolean).join(" ")} {...rest}>
            {children}
        </Tag>
    );
}

function Above<T extends React.ElementType = "div">({ breakpoint, as, className, children, ...rest }: ShowProps<T>) {
    const Tag = as ?? "div";
    return (
        <Tag className={[styles[`above--${breakpoint}`], className].filter(Boolean).join(" ")} {...rest}>
            {children}
        </Tag>
    );
}

export const Show = { Below, Above };
